import { render, staticRenderFns } from "./SueldosEmpresaHome.vue?vue&type=template&id=6d2a2b76&scoped=true&"
import script from "./SueldosEmpresaHome.vue?vue&type=script&lang=js&"
export * from "./SueldosEmpresaHome.vue?vue&type=script&lang=js&"
import style0 from "./SueldosEmpresaHome.vue?vue&type=style&index=0&id=6d2a2b76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2a2b76",
  null
  
)

export default component.exports